import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { history } from 'nallian-shared-ui/lib/config/history';
import HasRight from 'nallian-shared-ui/lib/layout/rights/HasRight';
import { Button, PageContent, PageTitle } from 'nallian-shared-ui/lib/components';
import VehiclesOverviewTable from './VehiclesOverviewTable';
import NewVehicleModal from './NewVehicleModal';
import VehicleSidebar from '../../vehicleSidebar/components/VehicleSidebar';

const VEHICLES_CREATE_RIGHT = 'vehicles/create';

export const VEHICLES_ACTIONS = {
  EDIT: 'edit',
  NEW: 'new',
  DETAILS: 'details',
};

const VehiclesOverview = ({ pageTitle, noAddVehicle, baseUrl, isPrivate }) => {
  const { t } = useTranslation();
  const { action, actionId, subActionId, subAction } = useParams();

  return (
    <>
      <PageTitle content={pageTitle} />
      <HasRight right={VEHICLES_CREATE_RIGHT}>
        <NewVehicleModal open={!!action && action === VEHICLES_ACTIONS.NEW} returnRoute={baseUrl} />
      </HasRight>
      <VehicleSidebar
        vehicleId={((action && action === VEHICLES_ACTIONS.DETAILS) || undefined) && actionId}
        sidebarAction={subAction}
        sidebarActionId={subActionId}
        baseUrl={baseUrl}
        sidebarUrl={`${baseUrl}/${VEHICLES_ACTIONS.DETAILS}/${actionId}`}
      />
      <PageContent>
        {!noAddVehicle && (
          <HasRight right={VEHICLES_CREATE_RIGHT}>
            <Button
              onClick={() =>
                history.push(`${baseUrl}/${VEHICLES_ACTIONS.NEW}`, {
                  goBack: true,
                })
              }
              content={t('addVehicle')}
              icon="add"
              primary
            />
          </HasRight>
        )}
        <VehiclesOverviewTable baseUrl={baseUrl} isPrivate={isPrivate} />
      </PageContent>
    </>
  );
};

VehiclesOverview.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  baseUrl: PropTypes.string.isRequired,
  isPrivate: PropTypes.bool.isRequired,
  noAddVehicle: PropTypes.bool,
};
VehiclesOverview.defaultProps = {
  noAddVehicle: false,
};

export default VehiclesOverview;
